module.exports = __webpack_public_path__ + "img/jiezhon.e4900bf5.png";